import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import { GameService } from '@services/game.service';
import { SessionService } from '@services/session.service';
import { TransactionService } from '@services/transaction.service';

export const gameResolver: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);
  const gameService = inject(GameService);
  const transactionService = inject(TransactionService);

  if (session.game()) {
    return true;
  }

  return gameService.fetchGame().pipe(
    switchMap((game) =>
      transactionService.fetchCurrentTransaction().pipe(
        catchError(() => of(null)),
        map(() => game),
      ),
    ),
    map(() => true),
    catchError(() => {
      void router.navigate(['/error'], { queryParamsHandling: 'preserve' });
      return of(false);
    }),
  );
};
